import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import Button from "@mui/material/Button";
import { useTheme, styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gallery1 from "../../../assets/innovation/ideas_1.png";
import gallery2 from "../../../assets/innovation/ideas_2.png";
import gallery3 from "../../../assets/innovation/ideas_3.png";
import gallery4 from "../../../assets/innovation/ideas_4.png";
import gallery5 from "../../../assets/innovation/ideas_5.png";
import gallery6 from "../../../assets/innovation/ideas_6.png";

const ColorButton = styled(Button)(() => ({
  color: "#071783",
  width: 185,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#F2C844",
  borderColor: "#F2C844",
  "&:hover": {
    color: "#071783",
    backgroundColor: "#fff",
    borderColor: "#fff",
  },
}));

const Ideas = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box margin={{ xs: "25% 0%", sm: "10% 0%" }}>
      <Typography
        variant="h2"
        color="#071783"
        fontWeight={800}
        padding={"1% 0% 1% 0%"}
        fontFamily={"Kaushan Script"}
        textAlign={"left"}
      >
        Call for Bold Ideas
      </Typography>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "60vh", sm: "550px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"oof_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "32%" }}
          />
        ))}
        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
      <Box marginTop={"4%"} display={"flex"} justifyContent={"center"}>
        <ColorButton
          component={"a"}
          variant="contained"
          target="_blank"
          size="medium"
          href={"https://bit.ly/OORCInnovation2025"}
        >
          Submit your idea
        </ColorButton>
      </Box>
    </Box>
  );
};

export default Ideas;
